// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mini_actions_v2_button span.v-tooltip{position:absolute}.mini_actions_v2_button.v-btn{height:auto;min-width:0;margin:0}.mini_actions_v2_button.v-btn--active:before,.mini_actions_v2_button.v-btn:focus:before,.mini_actions_v2_button.v-btn:hover:before{background-color:transparent!important}", ""]);
// Exports
module.exports = exports;
